import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';

function ResetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("As senhas não correspondem.");
      return;
    }
    setIsLoading(true);
    const loadingToast = toast.loading('Redefinindo senha...');
    try {
      const response = await api.post('/auth/reset-password', { token, password });
      toast.dismiss(loadingToast);
      toast.success(response.data.message);
      navigate('/login');
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error.response?.data?.error || 'Ocorreu um erro.');
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Crie sua Nova Senha</h2>
      <form onSubmit={handleSubmit}>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Nova Senha" required />
        <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirme a Nova Senha" required />
        <button type="submit" disabled={isLoading}>{isLoading ? 'Salvando...' : 'Salvar Nova Senha'}</button>
      </form>
    </div>
  );
}
export default ResetPasswordPage;